/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：814
 */

module.exports = {
  tableDataDialog: "TableDataDialog_tableDataDialog__4V5Ab",
  defaultData: "TableDataDialog_defaultData__1RHy2",
  rowAndColumnCount: "TableDataDialog_rowAndColumnCount__1YvG8",
  itemCount: "TableDataDialog_itemCount__3u7tG",
  footer: "TableDataDialog_footer__1oSXI"
}
